import { CartItem } from '@features/product/types';
import { qdfoodApi } from './constant';
import { IProduct, IProductFilter } from '@type/product';
import { IResponse } from '@type/response';

export const PRODUCT_API = {
  urlGetProductRandom: `/product/random/web-user`,
  urlGetDetailProduct: (slug: string) => `/product/${slug}/web-user`,
  urlGetListProduct: `/product/web-user`,
  urlGetListCartProduct: `/product/cart/web-user`,
};

export default class productApi {
  static getListCartProduct(cartItems: { productId: string; quantity: number }[]) {
    return qdfoodApi().get<IResponse<CartItem>>(PRODUCT_API.urlGetListCartProduct, {
      params: {
        cartItems: JSON.stringify(cartItems),
      },
    });
  }

  static getListProduct(params?: IProductFilter) {
    return qdfoodApi().get<IResponse<IProduct>>(PRODUCT_API.urlGetListProduct, {
      params,
    });
  }

  static getProductRandom(params: IProductFilter, headers?: any) {
    return qdfoodApi().get<IResponse<IProduct>>(PRODUCT_API.urlGetProductRandom, {
      params,
      headers,
    });
  }

  static getDetailProduct(slug: string) {
    return qdfoodApi().get<IProduct>(PRODUCT_API.urlGetDetailProduct(slug));
  }
}
